// removed by extract-text-webpack-plugin
module.exports = {"TupleContainer":"_qZwn8","TupleContainerPrimary":"_3UMML","TupleContainerSecondary":"_3UpYt","Box1":"_1kQd5","Box2":"_2BhUZ","AirlineDetail":"_2jQr3","Price":"_3I6ce","Line":"_3TaUo","ArrivalDate":"_YQIT8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/Tuple.scss
// module id = 719
// module chunks = 0